"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinPriceFilter = void 0;
/**
 * Allows you to filter products in the recommendation frame for products more expensive than the indicated price
 */
var MinPriceFilter = /** @class */ (function () {
    /** @param minPrice Minimal product price to filter */
    function MinPriceFilter(minPrice) {
        this.enableMultiple = false;
        this.urlParam = 'filterpricemin';
        this.value = minPrice;
    }
    return MinPriceFilter;
}());
exports.MinPriceFilter = MinPriceFilter;
//# sourceMappingURL=MinPriceFilter.js.map